'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

require('../agent/android');

var _constant = require('../constant');

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 初始化桥
var init = function () {
  var myIntervalTimes = _constant2.default.DEFAULT_INTERVAL_TIMES;
  // webviewjavascriptbridge  version/5.2.0
  var ios = _underscore2.default.once(function () {
    return new Promise(function (resolve, reject) {
      var i = document.createElement('iframe');
      i.style.display = 'none';
      i.src = _constant2.default.IOS_BRIDGE_LOADED_ADDRESS;
      document.documentElement.appendChild(i);
      setTimeout(function () {
        document.documentElement.removeChild(i);
      }, 0);
      var _interval = setInterval(function () {
        if (window[_constant2.default.IOS_BRIDGE_NAME]) {
          clearInterval(_interval);
          _interval = null;
          resolve(window[_constant2.default.IOS_BRIDGE_NAME]);
        }
        if (myIntervalTimes < 0) {
          clearInterval(_interval);
          _interval = null;
          reject('get WebViewJavascriptBridge error');
        }
        myIntervalTimes--;
      }, 1000);
    });
  });
  var android = function android(context, invoker) {
    return function (bridge) {
      bridge.setInvokerOnce(context, invoker);
    };
  };
  return {
    ios: ios,
    android: android
  };
}();
var connect = function () {
  var ios = function ios() {
    return new Promise(function (res, rej) {
      var bridge = window[_constant2.default.IOS_BRIDGE_NAME];
      if (bridge) {
        return res(bridge);
      }
      init.ios().then(function (bridge) {
        return res(bridge);
      });
    });
  };
  var android = function android(context, invoker) {
    return new Promise(function (res, rej) {
      var bridge = window[_constant2.default.ANDROID_BRIDGE_NAME];
      var _init = init.android(context, invoker);
      if (bridge) {
        _init(bridge);
        res(bridge);
      } else {
        document.addEventListener(_constant2.default.ANDROID_BRIDGE_READY_EVENT, function () {
          bridge = window[_constant2.default.ANDROID_BRIDGE_NAME];
          _init(bridge);
          res(bridge);
        }, false);
      }
    });
  };
  return {
    ios: ios,
    android: android
  };
}();

exports.default = connect;